import { render, staticRenderFns } from "./renewal-to-examine.vue?vue&type=template&id=4a3dd177&scoped=true&"
import script from "./renewal-to-examine.vue?vue&type=script&lang=js&"
export * from "./renewal-to-examine.vue?vue&type=script&lang=js&"
import style0 from "./renewal-to-examine.vue?vue&type=style&index=0&id=4a3dd177&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3dd177",
  null
  
)

export default component.exports